import styled from "styled-components";
import Typography from "../../../designComponents/Typography";
import ReviewButtons from "./review/ReviewButtons";
import { LabelText, SectionTitle, StyledCard, ValueText } from "./styles";
import { PropertyDetailsType, PropertyFeaturesProps } from "./types";
const CategoryIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;

const fieldKey = "Rules";

const RulesCard = ({
  isAccepted,
  propertyDetail,
  setOpenReviewModal,
  hasPreviousReview,
  hasRecentReview,
  onViewReviews,
}: PropertyFeaturesProps) => {
  const groupedRulesByCategory = propertyDetail?.property?.rules?.reduce<
    Map<
      string,
      {
        category: { icon: string; title: string };
        rules: PropertyDetailsType["property"]["rules"];
      }
    >
  >((acc, val) => {
    if (acc.has(val.category._id)) {
      const existedRules = acc.get(val.category._id);
      const updatedRules = {
        category: { icon: val.category.icon, title: val.category.title },
        rules: [...(existedRules?.rules || []), val],
      };
      acc.set(val.category._id, updatedRules);
    } else {
      acc.set(val.category._id, {
        category: { icon: val.category.icon, title: val.category.title },
        rules: [val],
      });
    }
    return acc;
  }, new Map());

  return (
    <StyledCard style={{ margin: 0 }}>
      <SectionTitle>Rules</SectionTitle>
      {isAccepted !== null && (
        <Typography
          style={{
            alignItems: "center",
            gap: "6px",
            color: isAccepted ? "green" : "red",
            fontWeight: 600,
            fontSize: "1rem",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          {isAccepted ? "Accepted" : "Rejected"}
        </Typography>
      )}
      <ValueText>
        {propertyDetail?.property?.rules?.length === 0 ? "No Rules Yet" : null}
      </ValueText>
      {Array.from(groupedRulesByCategory.values())?.map((item, index) => {
        return (
          <div
            key={`${item?.category?.title}-${index}`}
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <CategoryIcon src={item.category.icon} alt="Category icon" />
              <ValueText>{item.category.title}</ValueText>
            </div>
            {item?.rules?.map((rule, ruleIndex) => (
              <div key={rule._id}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <LabelText>{ruleIndex + 1}. </LabelText>
                  <LabelText>{rule?.title}</LabelText>
                </div>
                <ValueText>{rule?.description}</ValueText>
              </div>
            ))}
          </div>
        );
      })}

      <ReviewButtons
        fieldKey={fieldKey}
        hasPreviousReview={hasPreviousReview}
        hasRecentReview={hasRecentReview}
        isAccepted={!!isAccepted}
        onViewReviews={onViewReviews}
        setOpenReviewModal={setOpenReviewModal}
        underReview={propertyDetail?.property.status === "UNDER_REVIEW"}
      />
    </StyledCard>
  );
};

export default RulesCard;
